import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { FormattedNumber } from '@dbk/format';
import Text from '../text';
import { NO_DATA } from '../../../constants';

function BaseNumber(props) {
  if (typeof props.value !== 'number' || props.value === null || props.value === undefined) {
    return (
      <Text {...props.renderProps}>
        {NO_DATA}
      </Text>
    );
  }

  return (
    <FormattedNumber {...props}>
      {props.children}
    </FormattedNumber>
  );
}

BaseNumber.defaultProps = {
  minimumFractionDigits: 2,
  style: 'decimal',
};

BaseNumber.propTypes = {
  ...Text.propTypes,
  ...FormattedNumber.propTypes,
  value: PropTypes.any,
};

export default pure(BaseNumber);
